import ChallengeView from "./challenge/ChallengeView";
import ModalPosition from "../../components/ModalPosition";
const Challenge = () => {
  return (
      <ModalPosition title={1467 } >
      <ChallengeView />
      </ModalPosition>
  );
};

export default Challenge;
